<template>
    <div class="bottomBg">
        <div class="bottomContent">
            <div class="aboutus">
                <div class="title">关于上考</div>
                <div class='name' @click="openAboutus">关于我们</div>
                <div class='name' @click="openUser">用户协议</div>
                <div class='name' @click="openPrivacyPolicy">隐私协议</div>
                <div class='name' @click="openService">联系我们</div>
            </div>
            <div class="joinGroup">
                <div class="title">加群学习</div>
                <div class="groupStudy">
                    <div class="service">
                        <img src="../assets/bottom/img.png">
                        <div class="tip">联系我们</div>
                    </div>
                    <div class="interaction">
                        <img :src="group">
                        <div class="tip">互动起来</div>
                    </div>

                </div>
            </div>
            <div class="downLoad">
                <div class="title">更多设备</div>
                <div class="downLoadLeft">
                    <div class="wxdown">
                        <img alt="QR Code" src="../assets/bottom/wximg.jpg"/>
                        <div class="tip">微信小程序</div>
                    </div>
                    <div class="appStore">
                        <div class="btn androidDown" @click="onDownload"><img src="../assets/android.png">APP Android下载</div>
                        <div class="btn iosDown"  @click="oniosDownload"><img src="../assets/ios.png">APP Store下载</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottomInfo">
            <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备2023012733号-3A</a>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {EventBus} from "@/plugins/EUtils";

export default {
    data(){
        return{
            group:'',
            groups:['204','2002','100101','100201','100301','200101','200301','200302','300201']
        }
    },
    computed: {
        ...mapGetters([
            'identityId',
        ])
    },
    methods:{
        getIdentityId(value){
            if(value){
                this.identity_id = EUtils.deepClone(value);
            }else{
                this.identity_id = this.identityId
            }
            const matched = this.isInGroups(this.identity_id)
            if(matched){
                this.group=require(`../assets/group/${matched}.png`)
            }else{
                this.group=require(`../assets/group/all.png`)
            }
        },
        isInGroups(value) {
            const val = String(value);
            return this.groups.find(group => val.startsWith(String(group)));
        },
        onDownload(){
            window.open('https://a.app.qq.com/o/simple.jsp?pkgname=schema.shangkao.net')
        },
        oniosDownload(){
            window.open('itms-apps://itunes.apple.com/cn/app/id6449732870?mt=8')
        },
        openService(){
            window.open('https://work.weixin.qq.com/kfid/kfc1aaaa420f6e30353')
        },
        openAboutus(){
            window.open('https://api.shangkao.com.cn/abouts/aboutus.html')
        },
        openUser(){
            window.open('https://api.shangkao.com.cn/abouts/user.html')
        },
        openPrivacyPolicy(){
            window.open('https://api.shangkao.com.cn/abouts/secret.html')
        }

    },
    created() {
        EventBus.$on('identity_id',this.getIdentityId)
    },
}
</script>

<style scoped lang="scss">
.bottomBg{
    border-top: 1px solid #e0e0e0;
    background: rgb(245, 246, 249);
    height: 250px;
    color: #333;
    box-sizing: border-box;
    .bottomContent{
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px 0 0px;
        box-sizing: border-box;
        .aboutus{
            width: 200px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            .title{
                margin-bottom: 20px;
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                color: #333;
            }
            .name{
                font-size: 12px;
                line-height: 18px;
                color: #666;
                margin-bottom: 8px;
                cursor: pointer;
            }
            .name:hover{
                font-weight: bold;
            }
        }
        .joinGroup{
            width: 220px;
            height: 175px;
            padding-left: 100px;
            padding-right: 100px;
            border-left: 1px solid #e0e0e0;
            .title{
                margin-bottom: 20px;
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                color: #333;
            }
            .groupStudy{
                display: flex;
                .service{
                    margin-right: 10px;
                }
                img{
                    width: 100px;
                    height: 100px;
                    display: block;
                }
                .tip{
                    font-size: 12px;
                    line-height: 16px;
                    color: #999;
                    text-align: center;
                    margin-top: 12px;
                }
            }
        }
        .downLoad{
            width: 520px;
            box-sizing: border-box;
            padding-left: 100px;
            border-left: 1px solid #e0e0e0;
            .title{
                margin-bottom: 20px;
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                color: #333;
            }
            .downLoadLeft{
                display: flex;
                .wxdown{
                    margin-right: 20px;
                    img{
                        width: 100px;
                        height: 100px;
                    }
                    .tip{
                        font-size: 12px;
                        line-height: 16px;
                        color: #999;
                        text-align: center;
                        margin-top: 12px;
                    }
                }
                .appStore{
                    .btn{
                        width: 200px;
                        height: 40px;
                        border: 1px solid #e6e6e6;
                        line-height: 40px;
                        text-align: center;
                        border-radius: 20px;
                        margin: 10px 0;
                        cursor: pointer;
                        img{
                            vertical-align: sub;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
    }
    .bottomInfo{
        text-align: center;
        margin: 20px 0;
        font-size: 12px;
        a{
            color: #333;
            text-decoration: none;
        }
        a:hover{
            color: #0285bd;
        }
    }
}
</style>
